

import React, { Component } from 'react';

import PrayerImg from '../../assets/images/ministries/Prayer.jpg';

class Prayer extends Component {
  render() {
    return (
      <section>
        <header id="page-title">
          <div className="container">
            <h1>Prayer</h1>
          </div>
        </header>
        <section className="container">

          <img src={PrayerImg} style={{ float: "right" }} alt="" />
          <p>
            Prayer is the bedrock of everything we do as a church. As such, it forms a central part of our Sunday services and our Connect Groups. <br /><br />
            However, prayer is so important that we also meet regularly as a church for the sole purpose of prayer.<br /><br />
            <ul style={{ listStyleType: "none" }}>
              <li><strong>Weekly Prayer Meeting:</strong> Sundays before each service (9:00-9:15am and 4:00-4:15pm) in the 'Session Room', CRCK building.</li>
              <li><strong>Prayer Meetings:</strong> Generally held the first Sunday of each month. Please see our <a href="https://www.facebook.com/CRCKingston" rel="noopener noreferrer">Facebook page</a> for the most current dates and times throughout the year.</li>
            </ul>
          </p>

        </section>
      </section>
    );
  }
}

export default Prayer;
